import React from "react"
import { AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/accordion"
import { Box } from "@chakra-ui/react"
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons"
import Card from "../card/Card.js"

export default function AccordionMenu(props) {
  return (
    <AccordionItem border="none">
      {({ isExpanded }) => (
        <>
          <Card boxShadow="rgb(140 152 164 / 25%) 0px 1px 6px 2px" borderRadius="8px" mb="1rem" padding="0px" w={{ base: "100%", md: "100%", lg: "100%" }}>
            <AccordionButton
              fontSize="1rem"
              lineHeight="1.5"
              fontWeight="600"
              border="none"
              borderRadius="7px"
              _active={{
                background: "transparent"
              }}
              _focus={{
                outline: "none",
                boxShadow: "none",
                background: "#fff"
              }}
              _hover={{
                background: "transparent"
              }}
            >
              <Box flex="1" textAlign="left" padding="12px 0px">
                <h3>{props.title}</h3>

              </Box>
              {isExpanded ? (
                < ChevronUpIcon w="24px" h="24px" color="rgba(0, 0, 0, 0.54)" fontWeight="400" />
              ) : (
                <ChevronDownIcon w="24px" h="24px" color="rgba(0, 0, 0, 0.54)" fontWeight="400" />
              )}
            </AccordionButton>
            <AccordionPanel pt="0px" textAlign="left" fontSize="1rem" w="100%" color="rgb(103, 119, 136)" fontWeight="400">
              {props.content}
            </AccordionPanel>
          </Card>
        </>
      )}
    </AccordionItem>
  )
}
